import { createWeavingAlert } from "../../_services/weaving_alert"
import { validateWeavingAlertBody } from "./model";

export const createWeavingAlertEvent = async (body) => {
    validateWeavingAlertBody(body);
    const res = await createWeavingAlert(body);
    if(!res.ok) throw new Error(res.error);

    return res; 
}
